import { render, staticRenderFns } from "./ViewFile.vue?vue&type=template&id=35256c1b&scoped=true"
import script from "./ViewFile.vue?vue&type=script&lang=js"
export * from "./ViewFile.vue?vue&type=script&lang=js"
import style0 from "./ViewFile.vue?vue&type=style&index=0&id=35256c1b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35256c1b",
  null
  
)

export default component.exports